import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectHouseId } from '../../../../selectors/filters';

import { fetchNearbyHousesInfo } from '../../../../services/offersHistory/fetchNearbyHousesInfo';
import { TAboutNearbyHousesData } from '../../../../types/offerHistory';
import { useApplicationContext } from '../../../../utils/applicationContext';

export const useGetAboutNearbyHousesData = () => {
  const context = useApplicationContext();
  const houseId = useSelector(selectHouseId);
  const [data, setData] = React.useState<TAboutNearbyHousesData | null>(null);
  const [error, setError] = React.useState<Error | null>(null);
  const [isFetching, setIsFetching] = React.useState<boolean>(false);

  const load = React.useCallback(async () => {
    try {
      setIsFetching(true);

      const res = await fetchNearbyHousesInfo(context, { houseId: houseId as number });
      setData(res);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setIsFetching(false);
    }
  }, [context, houseId]);

  return { data, load, error, isFetching };
};
